// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2AIco","productName":"Table_productName__2yuB-"};